export const IDEA = {
    // Save dialog
    saveDialog: 'idea-save-dialog',
    modeLinkButton: 'idea-mode-link-button',
    modeManualButton: 'idea-mode-manual-button',
    urlInput: 'idea-url-input',
    extractButton: 'idea-extract-button',
    locationInput: 'idea-location-input',
    categorySelect: 'idea-category-select',
    neighborhoodInput: 'idea-neighborhood-input',
    noteTextarea: 'idea-note-textarea',
    submitButton: 'idea-save-submit-button',
    previewCard: 'idea-preview-card',
    // Card / detail
    card: 'idea-card',
    cardMenuTrigger: 'idea-card-menu-trigger',
    cardMenuEdit: 'idea-card-menu-edit',
    cardMenuDelete: 'idea-card-menu-delete',
    cardDeleteConfirm: 'idea-card-delete-confirm',
    cardDeleteCancel: 'idea-card-delete-cancel',
    editDialog: 'idea-edit-dialog',
    editLocationInput: 'idea-edit-location-input',
    editCategorySelect: 'idea-edit-category-select',
    editNeighborhoodInput: 'idea-edit-neighborhood-input',
    editNoteTextarea: 'idea-edit-note-textarea',
    editBestTimeSelect: 'idea-edit-best-time-select',
    editSourceUrlInput: 'idea-edit-source-url-input',
    editSubmitButton: 'idea-edit-submit-button',
    editCancelButton: 'idea-edit-cancel-button',
    detailDialog: 'idea-detail-dialog',
    openSourceLink: 'idea-open-source-link',
    upvoteButton: 'idea-upvote-button',
    downvoteButton: 'idea-downvote-button',
    // Trip Ideas tab
    tripAddIdeaButton: 'trip-add-idea-button',
    tripCategoryFilter: 'trip-category-filter',
    tripSortSelect: 'trip-sort-select',
    tripIdeasGrid: 'trip-ideas-grid',
    tripIdeasEmpty: 'trip-ideas-empty',
};
